module.exports = __webpack_public_path__ + "img/mountains.e4e6edb9.jpg";